import * as React from 'react';
import frLocale from 'date-fns/locale/fr';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import {MobileTimePicker} from '@mui/x-date-pickers/MobileTimePicker';
import {styled} from '@mui/material/styles';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const TimePickerComponent = ({
  showHour,
  setHour,
  validated,
  disabled = false,
}) => {
  const [showTmpHour, setTmpHour] = React.useState(showHour);

  React.useEffect(() => {
    setTmpHour(showHour);
  }, [showHour]);

  const CssTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.23)',
      },
    },
    '& .MuiOutlinedInput-root.Mui-error': {
      '& fieldset': {
        borderColor: validated ? 'rgb(211,57,49)' : 'rgba(0, 0, 0, 0.23)',
      },
    },
    '& .MuiInputLabel-root.Mui-error': {
      color: validated ? 'rgb(211,57,49)' : 'rgb(108,117,125)',
    },
    '& .MuiOutlinedInput-root.Mui-error.Mui-focused': {
      '& fieldset': {
        borderColor: validated ? 'rgb(211,57,49)' : 'rgb(25,118,210)',
      },
    },
    '& label.Mui-focused.Mui-error': {
      color: validated ? 'rgb(211,57,49)' : 'rgb(25,118,210)',
    },
  });

  const handleSetToCurrentTime = (props) => {
    const now = new Date();
    setTmpHour(now);
    setHour(now);
    props.onAccept(now);
  };

  const CustomActionBar = (props) => {
    return (
      <DialogActions>
        <Button
          onClick={() => handleSetToCurrentTime(props)}
          color="primary"
        >
          Maintenant
        </Button>
        <Button onClick={props.onCancel} color="primary">
          Annuler
        </Button>
        <Button onClick={() => props.onAccept(showTmpHour)} color="primary">
          OK
        </Button>
      </DialogActions>
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={frLocale}>
      <Stack spacing={3}>
        <div
          style={{
            position: 'relative',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <MobileTimePicker
            label={null}
            value={showTmpHour} // Always use the synchronized local state
            onChange={(newValue) => {
              setTmpHour(newValue); // Update the local state when the user changes the time
            }}
            onAccept={(newValue) => {
              setHour(newValue); // Update the parent state when accepted
              setTmpHour(newValue); // Ensure local state matches the parent state
            }}
            disabled={disabled}
            components={{
              ActionBar: CustomActionBar, // Use the custom action bar
            }}
            renderInput={(params) => (
              <CssTextField
                id="outlined-size-small"
                size="small"
                style={{zIndex: 1, width: '100%'}}
                {...params}
              />
            )}
          />
          <div
            style={{
              position: 'absolute',
              display: 'block',
              marginRight: 8,
              cursor: 'pointer',
            }}
          >
            <AccessTimeIcon />
          </div>
        </div>
      </Stack>
    </LocalizationProvider>
  );
};

export default TimePickerComponent;
